import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import FormPartial from './FormPartial.js';
import Vak from '../../models/Vak.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const navigate = useNavigate();
  const vakObj = new Vak();
  const [vak, setVak] = useState(vakObj.toStateJson());
  const [createApi] = getApi('createGlk')

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      navigate("/vak");
      toast.success("Successfully Created.");
    } catch(error) {
      vakObj.set_api_errors(error.data.data.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord((new Vak(vak)).toApiJson());
    } catch(error){
      setVak(new Vak(vak));
    }
  }

  const handleCancelFunction = () => {
    navigate('/vak');
  }

  return (
    <Page
      uiPage={uiManager.getUiPage(PAGES.NewVoltUpAllocationKitPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Voltup Allocation Kit", url: '/vak'}, { label: "Generate New VAK" }]}
      className={'new-vak-page'}
    >
      <PageContentWrapper contentHeading={"Generate New VAK"}>
        <div className='m-3'>
          <div className='mb-4 col-md-12'>
            <form className="row g-3" autoComplete="off">
              <FormPartial vak={vak} setVak={setVak} />
              <div className='mb-4 col-md-12'>
                <div >
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                  </button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Create VAK
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
  );

}

export default New;